module.exports = __webpack_public_path__ + "static/media/soeren.4769aef7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/soeren.jpg
// module id = 610
// module chunks = 0